<nav
  id="nav-header"
  class="navbar navbar-expand-lg navbar-light nav-header-pfm py-2 py-lg-0"
  [style.opacity]="headerStyles.opacity"
  [ngClass]="headerStyles.class!">
  <div class="container-fluid p-0">
    <div class="col-3 col-md-2 ps-1 px-md-3 px-lg-5 d-none d-md-block">
      <img loading="lazy" [src]="environment.assetsURL + 'img/logos/ssl-encryption.webp'" class="img-fluid" width="624" height="250" />
    </div>
    <div class="col-6 col-md-2 ps-1 px-md-3 px-lg-5 text-center mx-auto">
      <div class="countdown-nav p-0">
        <div class="text-center d-flex align-items-center justify-content-center">
          <p class="countdown-text me-2">Offers Expire In</p>
          <div class="countdown-box">
            <div class="time-content">
              <div class="time-item">
                <span class="time-number">{{ getMinutes() }}</span>
              </div>
              <span class="time-separator"></span>
              <div class="time-item">
                <span class="time-number">{{ getSeconds() }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="countdown-labels d-flex justify-content-center">
          <div class="time-label text-center">Minutes</div>
          <div class="time-label text-center">Seconds</div>
        </div>
      </div>
    </div>
    <div class="col-3 col-md-2 pe-1 px-md-2 py-lg-2 px-xxl-4 text-center d-none d-md-block" *ngIf="FunnelFlow.PathLogo; else ImagePFMDefault">
      <img loading="lazy"
        [src]="FunnelFlow.PathLogo"
        [ngClass]="{
          'header-cobrand-logo-verify': showClassVerify,
          'header-cobrand-logo': !showClassVerify
        }" loading="lazy" bh-id="2-step-banner-cobrand-img"
      />
    </div>
    <ng-template #ImagePFMDefault>
      <div class="col-3 col-md-2 pe-1 px-md-3 px-lg-5 d-none d-md-block">
        <img loading="lazy"
          [src]="headerStyles.logo" alt="Logo Black"
          [ngClass]="{
            'header-cobrand-logo-verify': showClassVerify,
            'header-cobrand-logo img-fluid': !showClassVerify
          }" loading="lazy" bh-id="2-step-banner-default-logo-img"
        />
      </div>
    </ng-template>
  </div>
</nav>
